import axios from "axios";
import jsonFormData from "json-form-data";

const prepareData = (data) => {
  return jsonFormData({ administration_automated_invoice: data }, { showLeafArrayIndexes: false });
};

// Plural Actions
export const GET_ADMINISTRATION_AUTOMATED_INVOICES = "get_administration_automated_invoices";
export const getAdministrationAutomatedInvoices = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = query ? `/administration/automated_invoices.json?${query}` : `/administration/automated_invoices.json`;
  const request = axios.get(url);
  return {
    type: GET_ADMINISTRATION_AUTOMATED_INVOICES,
    payload: request,
  };
};

// Singular Actions
export const CREATE_ADMINISTRATION_AUTOMATED_INVOICE = "create_administration_automated_invoice";
export const createAdministrationAutomatedInvoice = (data) => {
  const url = `/administration/automated_invoices.json`;
  const request = axios({ method: "post", url: url, data: prepareData(data) });
  return {
    type: CREATE_ADMINISTRATION_AUTOMATED_INVOICE,
    payload: request,
  };
};

export const GET_ADMINISTRATION_AUTOMATED_INVOICE = "get_administration_automated_invoice";
export const getAdministrationAutomatedInvoice = (id) => {
  const url = `/administration/automated_invoices/${id}.json`;
  const request = axios.get(url);
  return {
    type: GET_ADMINISTRATION_AUTOMATED_INVOICE,
    payload: request,
  };
};

export const UPDATE_ADMINISTRATION_AUTOMATED_INVOICE = "update_administration_automated_invoice";
export const updateAdministrationAutomatedInvoice = (id, data) => {
  const url = `/administration/automated_invoices/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data) });
  return {
    type: UPDATE_ADMINISTRATION_AUTOMATED_INVOICE,
    payload: request,
  };
};

export const COMPLETE_ADMINISTRATION_AUTOMATED_INVOICE = "complete_administration_automated_invoice";
export const completeAdministrationAutomatedInvoice = (id) => {
  const url = `/administration/automated_invoices/${id}/complete.json`;
  const request = axios.put(url);
  return {
    type: COMPLETE_ADMINISTRATION_AUTOMATED_INVOICE,
    payload: request,
  };
};

export const WEIRD_ADMINISTRATION_AUTOMATED_INVOICE = "weird_administration_automated_invoice";
export const weirdAdministrationAutomatedInvoice = (id) => {
  const url = `/administration/automated_invoices/${id}/weird.json`;
  const request = axios.put(url);
  return {
    type: WEIRD_ADMINISTRATION_AUTOMATED_INVOICE,
    payload: request,
  };
};

export const CANCEL_ADMINISTRATION_AUTOMATED_INVOICE = "cancel_administration_automated_invoice";
export const cancelAdministrationAutomatedInvoice = (id) => {
  const url = `/administration/automated_invoices/${id}/cancel.json`;
  const request = axios.put(url);
  return {
    type: CANCEL_ADMINISTRATION_AUTOMATED_INVOICE,
    payload: request,
  };
};

export const DESTROY_ADMINISTRATION_AUTOMATED_INVOICE = "destroy_administration_automated_invoice";
export const destroyAdministrationAutomatedInvoice = (id) => {
  const url = `/administration/automated_invoices/${id}.json`;
  const request = axios({ method: "delete", url: url });
  return {
    type: DESTROY_ADMINISTRATION_AUTOMATED_INVOICE,
    payload: request,
  };
};

// Action Cable status update (from WebSocket)
export const ADMINISTRATION_AUTOMATED_INVOICE_STATUS_UPDATE = "administration_automated_invoice_status_update";

// Temp Invoices Actions
// Upload temp automated invoice
export const UPLOAD_ADMINISTRATION_AUTOMATED_INVOICE = "upload_administration_automated_invoice";
export const uploadAdministrationAutomatedInvoice = (data) => {
  return {
    type: UPLOAD_ADMINISTRATION_AUTOMATED_INVOICE,
    data: data,
  };
};
